const defaultPagination = {
  sizePerPage: 10,
  sizePerPageList: [
    {
      text: '10',
      value: 10,
    },
    {
      text: '20',
      value: 20,
    },
    {
      text: '50',
      value: 50,
    },
  ],
};

const defaultTranslations = {
  clearFilters: 'Clear filters',
  clearRadioFilter: 'Clear radio filter',
  datePlaceholder: 'Placeholder',
  dateRangeEndPlaceholder: 'End date',
  dateRangeStartPlaceholder: 'Start date',
  filterColumn: 'Filter column',
  moreFiltersSelected: 'More filters selected',
  noMultiselectOptions: 'No multi select options',
  noResults: 'No results found',
  pageSize: 'Page size',
  removeTag: 'Remove tag',
};

export const defaultProps = {
  keyField: 'id',
  pagination: defaultPagination,
  translations: defaultTranslations,
  options: {
    pagination: true,
  },
  showPagination: true,
  showRowActions: true,
};
